import React from 'react';
import Transactions from '@components/transactions/transactions';

import { useAppSelector } from '@store/hooks';

import { IUserSession } from '@entities/user-session';

import { serverFetch } from '@flc/server';
import { UserBalanceType } from '@src/core/enums/user-balance-type';
import { Currency } from '@src/core/enums/currency';

const TransactionsHistory = () => {
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    return (
        <Transactions
            userId={userSession.userId}
            hideInitiator={true}
            isViewMode={true}
            useTagRequired={userSession.useTagRequired}
            tag={userSession.tag}
            currency={Currency.Usd}
            serverFetch={serverFetch}
        />
    );
};

export default TransactionsHistory;
